<template>
  <card-item card="item_value" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>